import * as api from '../../../api'
import * as moment from 'moment'

const defaultServiceInProgress = {
  serviceId: '',
  subServiceId: '',
  concreteServiceId: '',
  concreteServiceLevelId: null,
  optionsIds: [],
  masterId: '',
  time: '',
  date: moment().format('YYYY-MM-DD'),
}

export default {
  namespaced: true,
  state: {
    companyId: '',
    date: moment().format('YYYY-MM-DD'),
    timeRange: null,
    currentSalonId: '',
    currentEditServiceIdx: null,
    serviceInProgress: {
      ...defaultServiceInProgress
    },
    selectedServices: [],   // list of selected services. Cart.
    orderedServices: [],    // list of all services ordered in the past. Not used
    customer: {
      fullName: '',
      phone: '',
      confirmedAgreement: false,
      gender: '',
      priority: ''
    },
    creatingError: '',
    companySettings: {}
  },

  getters: {
    finalCost: (state, getters, rootState, rootGetters) => {
      const salonId = state.currentSalonId
      const selectedServices = state.selectedServices
      let is_fixed_price = true
      const final_cost = selectedServices.reduce((acc, {
        serviceId,
        subServiceId,
        concreteServiceId,
        concreteServiceLevelId,
        optionsIds
      }) => {
        const concreteService = rootGetters['salons/getConcreteService'](salonId, serviceId, subServiceId, concreteServiceId, concreteServiceLevelId)
        if (concreteService) {
          if (!concreteService.is_fixed_price)
            is_fixed_price = false
          let options = undefined
          if (concreteService.options)
            options = concreteService.options
          const {
            price
          } = concreteService
          const selectedOptions = options && options.filter(({
            id
          }) => optionsIds.includes(id))
          //@TODO Remove Number.parserInt when option price become number instead string
          const optionsPrice = selectedOptions && selectedOptions.reduce((acc, {
            price
          }) => acc + Number.parseInt(price), 0)
          return acc + price + (optionsPrice ? optionsPrice : 0)
        } else {
          return acc
        }
      }, 0)

      if (is_fixed_price)
        return final_cost
      return 'от ' + final_cost
    },
    getCompanyId (state) {
      return state.companyId
    },
    getSalonId (state) {
      return state.currentSalonId
    },
    getCustomer (state) {
      return state.customer
    },
    getServices (state) {
      return state.serviceInProgress
    }
  },

  actions: {
    async selectSalon({
      dispatch,
      commit,
      state
    }, salonId) {
      commit('setCurrentSalonId', parseInt(salonId))
      // dispatch('salons/fetchSalon', salonId, { root: true })
    },
    async selectGender({
      dispatch,
      commit,
      state
    }, {
      salonId,
      gender
    }) {
      commit('setCustomerGender', gender)
      await dispatch('salons/fetchSalon', {
        salonId,
        gender
      }, {
        root: true
      })
    },
    async sentForm({
      dispatch,
      commit,
      state
    }) {
      const data = {
        salon_id: state.currentSalonId,
        customer_name: state.customer.fullName,
        customer_phone: state.customer.phone,
        events: state.selectedServices.map((service) => {
          const option_ids = service.optionsIds.filter(e => e != '').map(e => parseInt(e))
          return {
            employee_id: service.masterId,
            service_id: service.concreteServiceId,
            option_ids,
            start_time: service.date + 'T' + service.time[0] + ':00',
            service_level_id: service.concreteServiceLevelId
          }
        })
      };
      return await api.createEvent(data).then(() => {
        commit('setOrderedServices');
        commit('clearSelectedService');
        commit('clearCreatingError');
        return true
      }).catch(err => {
        if (err.response && err.response.status === 400){
          if(err.response.data['non_field_errors'])
            commit('setCreatingError', err.response.data['non_field_errors'].join('\n'));
          else
            commit('setCreatingError', JSON.stringify(err.response.data));
        }
        else{
          commit('setCreatingError', err.toLocaleString());
        }

        return false
      });
    },
    async fetchCompanySettings(){
      return await api.getCompanySettings();
    },
    clearGender({commit}) {
      commit('genderClearing')
    },
    clearServiceInProgress({commit}) {
      commit('serviceInProgressClearing')
    },
  },
  mutations: {
    setCompanyId(state, companyId) {
      state.companyId = companyId
    },
    setCustomerName(state, fullName) {
      state.customer.fullName = fullName
    },

    setCustomerPhone(state, phone) {
      state.customer.phone = phone
    },

    setCustomerGender(state, gender) {
      state.customer.gender = gender
    },

    setCustomerPriority(state, priority) {
      state.customer.priority = priority
    },

    setCustomerServiceLevel(state, level) {
      state.serviceInProgress.concreteServiceLevelId = level
    },

    confirmAgreement(state, confirmed) {
      state.customer.confirmedAgreement = confirmed
    },

    setCurrentSalonId(state, id) {
      // если сменили филиал то сбрасываем выбранные услуги
      if (state.currentSalonId !== id) {
        state.currentEditServiceIdx = null
        state.selectedServices = []
        state.serviceInProgress = {
          ...defaultServiceInProgress
        }
      }
      state.currentSalonId = id
    },

    setDate(state, date) {
      state.date = date;
      state.serviceInProgress.date = date;
    },

    setTimeRange(state, timeRange) {
      state.timeRange = timeRange
    },

    currentEditServiceIdx(state, idx) {
      state.currentEditServiceIdx = idx
      state.serviceInProgress = state.selectedServices[idx]
    },

    setServiceInProgressData(state, serviceData) {
      state.serviceInProgress = {
        ...state.serviceInProgress,
        ...serviceData
      }
    },
    setTime(state, time) {
      state.serviceInProgress.time = time
    },

    deleteSelectedService(state, idx) {
      state.selectedServices.splice(idx, 1)
    },

    saveService(state) {
      const {
        currentEditServiceIdx,
        serviceInProgress
      } = state
      if (state.currentEditServiceIdx === null) {
        state.selectedServices.push(serviceInProgress)
      } else {
        state.selectedServices.splice(currentEditServiceIdx, 1, serviceInProgress)
      }

      state.currentEditServiceIdx = null
      state.serviceInProgress = defaultServiceInProgress
    },

    setOrderedServices(state) {
      state.orderedServices = [...state.orderedServices, ...state.selectedServices];
    },
    clearSelectedService(state) {
      state.selectedServices = [];
    },
    async readCompanySettings(state) {
      try {
        state.companySettings = await api.getCompanySettings();
        if (localStorage.hasOwnProperty('enable_adv') && localStorage.getItem('enable_adv') === 'true'){
          state.companySettings.is_enabled_adv = true;
        }
      } catch (error) {
        console.log('readCompanySettings: ', error)
      }
    },
    genderClearing(state) {
      state.customer.gender = '';
    },
    serviceInProgressClearing(state) {
      state.serviceInProgress = {
        ...defaultServiceInProgress
      }
    },
    clearCreatingError(state){
      state.creatingError = '';
    },
    setCreatingError(state, creatingError){
      console.log(state, creatingError);
      state.creatingError = creatingError;
    }
  }
}
